import React from 'react';

import './Alert.less';

/**
 *
 * @param {{
 *  show?:boolean;
 *  message?:string|null;
 *  type?:'yellow'|'green'|'purple'|'red';
 *  onClose?():void;
 *  isBusy?:boolean;
 *  icon?:React.ReactNode;
 *  className?:string;
 *  children?:React.ReactNode;
 * }} props
 * @returns {React.ReactElement|null}
 */
export const Alert = (props) => {
  const { show = true, message, type, onClose, icon, className, children } = props;

  return show ? <div className={[`lsn-message lsn-${type || 'save'}-message`, className].filter(Boolean).join(' ')} tabIndex={0} role="alert">
    <span className="lsn-message-img" hidden={!icon && !type}>
      {icon}
      {!icon && type === 'yellow' ? <i className='far fa-save color-dark-yellow save'></i> : void 0}
      {!icon && type === 'green' ? <i className='far fa-check-circle color-dark-green submit' hidden={type !== 'green'}></i> : void 0}
      {!icon && type === 'purple' ? <i className='far fa-minus-circle color-dark-purple decline' hidden={type !== 'purple'}></i> : void 0}
      {!icon && type === 'red' ? <i className='far fa-exclamation-triangle color-dark-red error' hidden={type !== 'red'}></i> : void 0}
    </span>
    <span className="lsn-message-text">{message?.split('\n').flatMap(m => [m, <br />])}{children}</span>
    {onClose ? <span
      className="fa fa-times lsn-message-close-icon color-dark-red"
      role="button"
      aria-label={`Close message`}
      tabIndex={0}
      onKeyPress={() => onClose()}
      onClick={() => onClose()}
    /> : null}
  </div> : null;
}
